import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import { resetForgotPassword } from "../../../services/auth-service/authService";
import { toastError, toastSuccess } from "../../../utils/toast";

function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const data = searchParams.get("data") || "";

  const [formData, setFormData] = useState({ password: "", confirmPassword: "" });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    try {
      await resetForgotPassword({
        data,
        password:         formData.password,
        password_confirm: formData.confirmPassword,
      });
      toastSuccess("Password reset successfully!");
      navigate("/login");
    } catch (error: any) {
      toastError(error.response?.data?.message ?? "Reset failed");
    }
  }

  return (
    <div
      style={{
        minHeight:      "calc(100vh - 68px)",
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        background:     "linear-gradient(135deg, #f8fafc 0%, #fef2f2 100%)",
        padding:        "2rem 1rem",
      }}
    >
      <div
        style={{
          width:        "100%",
          maxWidth:     420,
          background:   "#ffffff",
          borderRadius: 20,
          boxShadow:    "0 8px 40px rgba(0,0,0,0.09)",
          border:       "1.5px solid #f0f4f8",
          padding:      "2.5rem 2rem 2rem",
        }}
      >
        {/* Brand icon */}
        <div className="text-center mb-4">
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 56, height: 56, background: "rgba(237,27,36,0.08)", borderRadius: "50%", marginBottom: "0.75rem" }}>
            <FaLock size={22} color="#ed1b24" />
          </div>
          <h4 style={{ fontWeight: 800, color: "#1e293b", marginBottom: "0.25rem", letterSpacing: "-0.03em" }}>
            Reset Password
          </h4>
          <p style={{ color: "#94a3b8", fontSize: "0.875rem", margin: 0 }}>
            Enter your new password below
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="fp-password"
              placeholder="New Password"
              value={formData.password}
              onChange={(e) => handleChange(e, "password")}
              required
            />
            <label htmlFor="fp-password">New Password</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="fp-confirm"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={(e) => handleChange(e, "confirmPassword")}
              required
            />
            <label htmlFor="fp-confirm">Confirm Password</label>
          </div>

          <button type="submit" className="btn btn-danger w-100 fw-bold py-2 mt-1">
            Set New Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
